import { render, staticRenderFns } from "./Cribs.vue?vue&type=template&id=b3f1f1d4&scoped=true"
import script from "./Cribs.vue?vue&type=script&lang=ts"
export * from "./Cribs.vue?vue&type=script&lang=ts"
import style0 from "./Cribs.vue?vue&type=style&index=0&id=b3f1f1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f1f1d4",
  null
  
)

export default component.exports